import styled from 'styled-components';
import FlightActiveSvg from '../../assets/verticals/flight-active.svg';

const FlightActiveIcon = styled(FlightActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4rem'};
height: ${props => props.height || '3.5rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default FlightActiveIcon;
